__turbopack_context__.v({
  "container": "EventPeriod-module__e6xvYq__container",
  "text": "EventPeriod-module__e6xvYq__text",
});
